import { useEffect } from 'react'
import { Euro, RussianRuble, X } from 'lucide-react'
import { useBodyScrollLock } from '../hooks'
import { PAYMENT_LINKS, PaymentCurrency } from '../constants/paymentLinks'

interface PaymentModalProps {
  isOpen: boolean
  onClose: () => void
  onPaymentSelect: (currency: PaymentCurrency) => void
}

const PaymentModal = ({
  isOpen,
  onClose,
  onPaymentSelect,
}: PaymentModalProps) => {
  useBodyScrollLock(isOpen)

  // Закрытие по клавише Escape
  useEffect(() => {
    const handleEscape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') {
        onClose()
      }
    }

    if (isOpen) {
      document.addEventListener('keydown', handleEscape)
      return () => document.removeEventListener('keydown', handleEscape)
    }
  }, [isOpen, onClose])

  if (!isOpen) return null

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  const handleRublesPayment = () => {
    // Переход к боту для оплаты в рублях
    window.open(PAYMENT_LINKS.RUB, '_self')
    onPaymentSelect('RUB')
  }

  const handleEuroPayment = () => {
    // Переход к боту для оплаты в евро
    window.open(PAYMENT_LINKS.EUR, '_self')
    onPaymentSelect('EUR')
  }

  return (
    <div className="payment-modal-overlay" onClick={handleOverlayClick}>
      <div className="payment-modal">
        <div className="payment-modal-header">
          <h2 className="payment-modal-title">Подтверждение оплаты</h2>
          <button
            className="payment-modal-close"
            onClick={onClose}
            aria-label="Закрыть"
          >
            <X size={20} />
          </button>
        </div>

        <div className="payment-modal-content">
          <p className="payment-modal-subtitle">
            Выберите подходящий вариант оплаты
          </p>

          <div className="payment-options">
            <button
              className="payment-option payment-option-rub payment-option-text"
              onClick={handleRublesPayment}
            >
              <RussianRuble size={24} />
              Оплатить Рублями
            </button>

            <button
              className="payment-option payment-option-eur payment-option-text"
              onClick={handleEuroPayment}
            >
              <Euro size={24} />
              Оплатить Евро
            </button>
          </div>

          <p className="payment-modal-description">
            После выбора способа оплаты, вы попадете в бота Secret Club, где
            сможете произвести оплату в выбранной валюте, удобным для вас
            способом.
          </p>
        </div>
      </div>
    </div>
  )
}

export default PaymentModal
